import { activityHistoryCollectionsSlice } from "../../slice";

export const { addActivityHistoryItem } = activityHistoryCollectionsSlice.actions;
